import { isAxiosError } from "axios";

export function getErrorMessage(error: any) {
  if (isAxiosError(error)) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}
